/** Estilos compartilhados dos popovers de ações de tickets e conversas. */
export const commandMenuStyles = (theme) => ({
  menuPaper: {
    borderRadius: 14,
    marginTop: 6,
    overflow: "visible",
    background: theme.palette.type === "dark" ? "#1c1f22" : "#ffffff",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(255, 255, 255, 0.06)"
      : "1px solid rgba(15, 23, 42, 0.06)",
    boxShadow: theme.palette.type === "dark"
      ? "0 20px 40px -12px rgba(0, 0, 0, 0.5), 0 6px 14px -4px rgba(0, 0, 0, 0.3)"
      : "0 20px 40px -12px rgba(15, 23, 42, 0.22), 0 6px 14px -4px rgba(15, 23, 42, 0.10)",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    padding: "6px 4px",
    minWidth: 232,
  },
  menuSection: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  menuEyebrow: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    padding: "8px 12px 4px",
    color: theme.palette.type === "dark" ? "#6b7380" : "#94A3B8",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "8px 10px",
    borderRadius: 8,
    border: "none",
    background: "transparent",
    width: "100%",
    cursor: "pointer",
    textAlign: "left",
    fontFamily: "inherit",
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#e6e8eb" : "#1a1a1a",
    transition: "background-color 140ms ease",
    animation: "$menuItemIn 200ms cubic-bezier(0.16, 1, 0.3, 1) both",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(15, 23, 42, 0.04)",
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.type === "dark" ? "#5B7CFF" : "#3D5CFD"}`,
      outlineOffset: 1,
    },
    "&:nth-child(1)": { animationDelay: "0ms" },
    "&:nth-child(2)": { animationDelay: "35ms" },
    "&:nth-child(3)": { animationDelay: "70ms" },
    "&:nth-child(4)": { animationDelay: "105ms" },
    "&:nth-child(5)": { animationDelay: "140ms" },
  },
  menuItemDanger: {
    color: theme.palette.type === "dark" ? "#fca5a5" : "#dc2626",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(220, 38, 38, 0.12)"
        : "rgba(220, 38, 38, 0.06)",
    },
  },
  menuIconBox: {
    width: 28,
    height: 28,
    flex: "0 0 28px",
    borderRadius: 8,
    display: "grid",
    placeItems: "center",
  },
  menuIconBoxCobalt: {
    background: theme.palette.type === "dark" ? "rgba(91, 124, 255, 0.16)" : "#EEF2FF",
    color: theme.palette.type === "dark" ? "#93a6ff" : "#3D5CFD",
  },
  menuIconBoxSlate: {
    background: theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.16)" : "#F1F5F9",
    color: theme.palette.type === "dark" ? "#cbd5e1" : "#475569",
  },
  menuIconBoxAmber: {
    background: theme.palette.type === "dark" ? "rgba(252, 211, 77, 0.14)" : "#FEF3C7",
    color: theme.palette.type === "dark" ? "#fbbf24" : "#B45309",
  },
  menuIconBoxRed: {
    background: theme.palette.type === "dark" ? "rgba(248, 113, 113, 0.14)" : "#FEE2E2",
    color: theme.palette.type === "dark" ? "#fca5a5" : "#dc2626",
  },
  menuLabel: {
    flex: 1,
    lineHeight: 1.2,
  },
  menuDivider: {
    height: 1,
    margin: "6px 8px",
    background: theme.palette.type === "dark"
      ? "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)"
      : "linear-gradient(90deg, transparent, #E2E8F0, transparent)",
  },
  "@keyframes menuItemIn": {
    "0%": { opacity: 0, transform: "translateY(4px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
});
